import AccountIcon from '@material-ui/icons/AccountCircle';

import AccountCoinEdit from './AccountCoinEdit';
import AccountCoinShow from './AccountCoinShow';
import AccountCoinCreate from './AccountCoinCreate';

export default {
    show: AccountCoinShow,
    icon: AccountIcon,
    edit: AccountCoinEdit,
    create: AccountCoinCreate,
};
